import React, { useState, useEffect, useRef } from "react";
import "../../App.css";


import FeatureSection from "../shared/FeatureSection";
import QuickLinksSection1 from "./QuickLinksSection1";
import {BackToProductsButton} from "../layout/BackButton";

// Updated Here Maps page with back button
function HereMapsPage({ handleNavClick }) {
  return (
    <div className="product-detail-page">
      {/* Back Arrow Button */}
      <BackToProductsButton handleNavClick={handleNavClick} />

      {/* Here Maps Header with Background */}
      <div className="here-header">
        <div className="section__container">
          <h2 className="section__title">Here Maps</h2>
          <p className="section__intro">
            HERE Technologies, commonly known as HERE Maps, is a leading provider of digital mapping, navigation, and location-based services.
          </p>
        </div>
      </div>
      {/* Detailed Content */}
      <div className="esri_content_bg">
        <FeatureSection
          title="About Here Maps"
          text="HERE is the world’s leading mapping company. Forty years ago, started with a digital map of San Francisco. Today, we set the standard for automotive-grade maps globally and partner to define the future of the software-defined vehicle. HERE Maps customers are leading automakers, logistics firms, mobility providers and technology brands.

            HERE delivers the world’s best unified map to their customers. A map with more precision, more flexibility and more control. A map that is powering the next generation of vehicle automation and safety, enabling innovation and efficiency, and driving sustainable growth across industries."
          imgSrc="/here.jpg"
          imgAlt="Spatial Analytics"
        />
        <section className="esri-about-section">
          <div className="section__container esri-about-container">
            <div className="esri-about-text">
              <h2>Maps & data</h2>
              <p>
                Build accurate maps and custom layers using fresh location data generated by hundreds of mapping vehicles worldwide. Elevate the comfort and safety of driving experiences with our portfolio of dynamic content services.
              </p>
              <br></br>
            </div>
            <div className="esri-about-image">
              <img src="products/Here/Maps & Data.png" alt="ESRI Logo" />
            </div>
          </div>
        </section>
        <FeatureSection
          title="Location services"
          text="Create connected journeys for fleets, passengers and businesses with advanced algorithms. Bring high-precision location awareness to your apps and devices to improve location accuracy and make journey planning easier."
          imgSrc="products/Here/Location Services.png"
          imgAlt="Spatial Analytics"
        />

        <FeatureSection
          title="Applications"
          text="Optimize last mile deliveries, track assets in real time and deliver the freshest SaaS automotive navigation. Find out how to minimize asset loss and reduce operating costs in your supply chain."
          imgSrc="products/Here/Application.png"
          imgAlt="Field Operations"
          reverse
        />
      </div>
      <QuickLinksSection1
        handleNavClick={handleNavClick}
        links={[
          { id: 'software-products', title: 'ESRI Software', icon: '/esri-logo.jpg', bgClass: 'esri-quick-bg' },
          { id: 'hardware-products', title: 'Idea Forge', icon: '/ideaforge1.jpg', bgClass: 'idea-quick-bg' },
          { id: 'maps-data-products', title: 'Planet Satellite', icon: '/planet.jpg', bgClass: 'planet-quick-bg' }
        ]}
      />
    </div>
  );
}

export default HereMapsPage;